import React from "react";
import { Grid, Typography, Card, CardContent, Button, makeStyles } from "@material-ui/core";
import { useDispatch } from "react-redux";
import Header from "../Landingpagecomponents/Header/header";
import Footer from "../Landingpagecomponents/Footer/Footer";
import * as AuthActions from "../store/actions/auth";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#eaeaea',
    minHeight: '100vh'
  },
  topSpacer: {
    backgroundColor: '#002D55',
    height: '15vh',
    padding: '2%'
  },
  cardWrap: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 24,
    marginBottom: 24,
    padding: '0 16px'
  },
  card: {
    width: '100%',
    maxWidth: 720,
    borderRadius: 18
  },
  actionRow: {
    marginTop: 24,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  button: {
    color: '#FFFFFF',
    backgroundColor: '#002D55',
    borderRadius: 12,
    '&:hover': {
      backgroundColor: '#fb741a'
    }
  }
}));

const PortalPendingActivation = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    await dispatch(AuthActions.logout());
  };

  return (
    <Grid container className={classes.root}>
      <Header />
      <Grid item xs={12} className={classes.topSpacer} />
      <Grid item xs={12} className={classes.cardWrap}>
        <Card className={classes.card}>
          <CardContent>
            <Typography variant="h4" style={{ color: '#002D55', marginBottom: 16 }}>
              Your booking is confirmed
            </Typography>
            <Typography variant="body1" style={{ marginBottom: 16 }}>
              Your portal has been created, but access to patient content stays locked until your clinic verifies your first attendance.
            </Typography>
            <Typography variant="body1" style={{ marginBottom: 16 }}>
              You can use the booking confirmation email for your appointment details. Once the clinic unlocks your account, the portal will open automatically the next time you sign in.
            </Typography>
            <Typography variant="body2" color="textSecondary">
              If you need to update your appointment before then, contact the clinic directly.
            </Typography>
            <div className={classes.actionRow}>
              <Button className={classes.button} variant="contained" onClick={handleLogout}>
                Sign out
              </Button>
            </div>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default PortalPendingActivation;